import { render, staticRenderFns } from "./SearchDoctor.vue?vue&type=template&id=b91d3168"
import script from "./SearchDoctor.vue?vue&type=script&lang=js"
export * from "./SearchDoctor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports